import { closeVariants, iconAddToCart } from "../icons";

export const templateVariants = (options, handle) => {
  const optionsHTML = options
    .map(
      (option, index) => `
        <div class="product-article__variants--var">
          <select id="option-${index}" class="product-article__variants--ul" data-option-index="${index}">
            <option value="" disabled selected class="product-article__variants--type">
              Selecciona ${option.name}
            </option>
            ${option.values
              .map(
                (value) =>
                  `<option value="${value}" class="product-article__variants--li">${value}</option>`
              )
              .join("")}
          </select>
        </div>
      `
    )
    .join("");

  return `
    <div class="product-article__variants" handle-product="${handle}">
      <button class="product-article__variants--close" aria-label="Cerrar">
        ${closeVariants}
      </button>
      <p class="product-article__variants--p">
        Selecciona una opción para agregar tu producto al carrito
      </p>
      ${optionsHTML}
        <button
          class="product-article__variants--add-to-cart add-to-cart product-article__action"
          data-product-id=""
        >
        <i>${iconAddToCart}</i>
          <div class="product-article__action--loader">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
        </button>
    </div>
  `;
};
